import type { ReactNode } from 'react';

export const symbol_person_pin: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M359-161H180q-24 0-42-18t-18-42v-600q0-25 18-42.5t42-17.5h600q24 0 42 17.5t18 42.5v600q0 24-18 42t-42 18H601L501-61q-5 5-10 7t-11 2q-6 0-11-2t-10-7L359-161Zm-179-97q60-56 136-90.5T480-383q88 0 164 34.5T780-258v-563H180v563Zm400-244q40-40 40-98t-40-98q-40-40-98-40t-98 40q-40 40-40 98t40 98q40 40 98 40t98-40ZM235-221h490v-9q-54-46-116-69.5T480-323q-67 0-129 23.5T235-230v9Zm192-324q-23-23-23-55t23-55q23-23 55-23t55 23q23 23 23 55t-23 55q-23 23-55 23t-55-23Zm53 5Z"
		/>
	</svg>
);
